module.exports = __webpack_public_path__ + "images/empty_profile_listener.6e85bd70efee6dec32403e34855bb910.png";